export class Division {
  public id?: number;
  public code: string;
  public name:  string;
  public description: string;
  public logo_name: string;
  public logo:  string;
}

export class DivisionSalesNetwork {
  public id?: number;
  public sales_network_id: number;
  public division_id: number;
  public sales_network_name?: string;
  public division_name?: string;
}

//todoNuova calsse per sostituire DivisionSalesNetwordk in getListExpanded per Estratto Conto
export class UserStoreDivisionDto {
  public division_sales_network_id?: number;
  public sales_network_id: number;
  public division_id: number;
  public sales_network_name?: string;
  public division_name?: string;
}







// WEBPACK FOOTER //
// ./src/app/models/division.model.ts